import { ref, onMounted, watch } from 'vue';

const isDark = ref(false);

export function useDarkMode() {
  // Al montar, leemos del storage o preferencia del sistema
  onMounted(() => {
    const storedTheme = localStorage.getItem('frontline-theme');

    if (storedTheme === 'dark') {
      isDark.value = true;
      document.documentElement.classList.add('dark');
    } else {
      isDark.value = false;
      document.documentElement.classList.remove('dark');
    }
  });

  // Observamos cambios para guardar y aplicar
  watch(isDark, (val) => {
    if (val) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('frontline-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('frontline-theme', 'light');
    }
  });

  const toggleDarkMode = () => isDark.value = !isDark.value;

  return { isDark, toggleDarkMode };
}